export enum Device {
  DESKTOP = 'desktop',
  MOBILE = 'mobile'
}
